export default {
  1: {
    imgStyle: {
      width: '0.5rem',
      height: '0.5rem',
      border: 0,
    },
    children: {
      0: {
        top: '3.15rem',
        left: '1.25rem',
      },
    },
  },
  2: {
    imgStyle: {
      width: '0.5rem',
      height: '0.5rem',
      border: 0,
    },
    children: {
      0: {
        top: '3.15rem',
        left: '1.25rem',
      },
      1: {
        top: '3.15rem',
        left: '1.8rem',
      },
    },
  },
  3: {
    imgStyle: {
      width: '0.5rem',
      height: '0.5rem',
      border: 0,
    },
    children: {
      0: {
        top: '3.15rem',
        left: '1.25rem',
      },
      1: {
        top: '3.15rem',
        left: '1.8rem',
      },
      2: {
        top: '3.15rem',
        left: '2.35rem',
      },
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/Editor/components/CropPageView/common/circleStylesLovelandCatalog.ts